type RouteLocation = {
  pathname: string;
  search?: string;
  hash?: string;
};

const ROUTE_HISTORY_KEY = 'home-asset-route-history';
const MAX_HISTORY_LENGTH = 30;
const BASE_PATHS = ['/x/assets/plaza', '/material-ui'];

const normalizePathname = (pathname = '') => {
  let normalizedPathname = pathname || '/';

  BASE_PATHS.forEach((basePath) => {
    while (
      normalizedPathname === basePath ||
      normalizedPathname.startsWith(`${basePath}/`)
    ) {
      normalizedPathname = normalizedPathname.slice(basePath.length) || '/';
    }
  });

  return normalizedPathname.startsWith('/')
    ? normalizedPathname
    : `/${normalizedPathname}`;
};

const getRouteUrl = (route: RouteLocation) => {
  return `${normalizePathname(route.pathname)}${route.search || ''}${
    route.hash || ''
  }`;
};

const readRouteHistory = (): RouteLocation[] => {
  try {
    const value = window.sessionStorage.getItem(ROUTE_HISTORY_KEY);
    if (!value) return [];
    const history = JSON.parse(value);
    if (!Array.isArray(history)) return [];
    return history.filter((item) => item?.pathname);
  } catch {
    return [];
  }
};

const writeRouteHistory = (history: RouteLocation[]) => {
  try {
    window.sessionStorage.setItem(
      ROUTE_HISTORY_KEY,
      JSON.stringify(history.slice(-MAX_HISTORY_LENGTH)),
    );
  } catch {
    // Ignore storage errors so routing never depends on sessionStorage availability.
  }
};

export const recordRouteHistory = (location: RouteLocation) => {
  if (!location?.pathname || location.pathname.includes('/blank')) return;

  const currentRoute = {
    pathname: normalizePathname(location.pathname),
    search: location.search || '',
    hash: location.hash || '',
  };
  const history = readRouteHistory();
  const lastRoute = history[history.length - 1];

  if (lastRoute && getRouteUrl(lastRoute) === getRouteUrl(currentRoute)) return;

  writeRouteHistory([...history, currentRoute]);
};

export const getPreviousRouteUrl = (currentLocation: RouteLocation) => {
  const history = readRouteHistory();
  const currentRouteUrl = currentLocation ? getRouteUrl(currentLocation) : '';

  for (let index = history.length - 2; index >= 0; index -= 1) {
    const routeUrl = getRouteUrl(history[index]);
    if (routeUrl && routeUrl !== currentRouteUrl) {
      return routeUrl;
    }
  }

  return '';
};
